/**
 * Documents API resource
 * Endpoint: /api/easyblocks/documents
 */

import { getApiBaseUrl, joinUrl, fetchJson } from "./client";
import type { DocumentGetParams, DocumentCreateParams, DocumentUpdateParams, DocumentResponse } from "./types";

/**
 * GET /api/easyblocks/documents?id={id}&locale={locale}
 * Retrieve a document by ID
 */
export async function getDocument(params: DocumentGetParams): Promise<DocumentResponse> {
  const url = new URL(joinUrl(getApiBaseUrl(), "documents"), window.location.origin);
  url.searchParams.set("id", String(params.id));
  if (params.locale) url.searchParams.set("locale", params.locale);
  if (params.page_item_id) url.searchParams.set("page_item_id", String(params.page_item_id));

  return await fetchJson<DocumentResponse>(url.toString(), {
    method: "GET",
    headers: { Accept: "application/json" },
    credentials: "same-origin",
  });
}

/**
 * POST /api/easyblocks/documents
 * Create a new document
 */
export async function createDocument(params: DocumentCreateParams): Promise<DocumentResponse> {
  const url = joinUrl(getApiBaseUrl(), "documents");

  return await fetchJson<DocumentResponse>(url, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    credentials: "same-origin",
    body: JSON.stringify({
      id: params.id ?? 0,
      version: params.version,
      entry: params.entry,
      page_item_id: params.page_item_id,
    }),
  });
}

/**
 * POST /api/easyblocks/documents
 * Update an existing document
 */
export async function updateDocument(params: DocumentUpdateParams): Promise<DocumentResponse> {
  const url = joinUrl(getApiBaseUrl(), "documents");

  return await fetchJson<DocumentResponse>(url, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    credentials: "same-origin",
    body: JSON.stringify({
      id: params.id,
      version: params.version,
      entry: params.entry,
      page_item_id: params.page_item_id,
      record_revision: params.record_revision,
    }),
  });
}
